<template>
    <div class="the-header">
        <img :src="this.$projectPath + '/image/robot.png'"/>
        <span class="title" v-if="!PageTitle">
          <span class="bigger">{{LogoName[0]}}</span>{{LogoName[1]}}
        </span>
        <span class="title" v-else>
          {{PageTitle}}
        </span>
    </div>
</template>

<script>
import {PageTitle} from '@/config/sys.config'
import {LogoName} from '@/config/sys.config'

export default {
    name: "the-header",
    mixins: [],
    props: {},
    components: {},
    data() {
        return {
          PageTitle,
          LogoName
        }
    },
    methods: {},
    mounted() { }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';
.the-header {
    height: $headerHeight;
    color: rgba(69, 125, 255, 1);
    font-size: 32px;
    display: flex;
    align-items: flex-start;
    font-weight: bold;
    img {
        position: relative;
        z-index: 99999;
        transform: translateY(-40px);
    }

    .title {
        display: flex;
        align-items: center;
    }

    .bigger {
        font-size: 38px;
        transform: translateY(3px);
    }
}
</style>
